import { render, staticRenderFns } from "./HistoricBookings.vue?vue&type=template&id=d95d3854&scoped=true"
import script from "./HistoricBookings.vue?vue&type=script&lang=js"
export * from "./HistoricBookings.vue?vue&type=script&lang=js"
import style0 from "./HistoricBookings.vue?vue&type=style&index=0&id=d95d3854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95d3854",
  null
  
)

export default component.exports